import React, {useEffect, useState} from 'react';
import {MapContainer, Popup} from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import './style.scss'

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import KmlLayer from "./KmlLayer";
import StopsLayer from "./StopsLayer";
import HikeLayer from "./HikeLayer";
import {useDispatch, useSelector} from "react-redux";
import ThemeLayer from "./ThemeLayer";
import TileLayers from "./TileLayers";
import {fetchStops} from "../../../../../data/booking/actions/map";
import ServicesLayer from "../../../../booking/components/map/leaflet/ServicesLayer";
import {isEmpty} from "lodash";
import {updateMapLayer} from "../../../../../data/booking/actions/map";
import {MAP_LAYER_IGN, MAP_OUTDOOR} from "../../../../../data/booking/constants/map_filters_type";

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

function Map() {
    const kmlData = useSelector(state => state.booking.map.kmlData)
    const {hike, moseOverHike, theme} = useSelector(state => state.booking.map)
    const bounds = useSelector(state => state.booking.map.bounds)
    const showStops = useSelector(state => state.booking.map.showStops)
    const showThemes = useSelector(state => state.booking.map.showThemes)
    const {services, hikes} = useSelector(state => state.booking.map.entities)
    const [map, setMap] = useState(null)
    const dispatch = useDispatch()

    useEffect(()=> {
        if(map && bounds.corner1){
            if(bounds.corner2){
                map.flyToBounds(L.latLngBounds(bounds.corner1, bounds.corner2));
            } else {
                map.flyTo(bounds.corner1, 14);
            }
        }
    }, [bounds, map != null])

    const fetchStopsAfterMove = () => {
        const {_northEast, _southWest} = map.getBounds()
        dispatch(fetchStops(_northEast, _southWest))
    }

    useEffect(() => {
        if(map) {
            map.on("dragend", () => fetchStopsAfterMove());
            map.on("zoomend", () => {
                fetchStopsAfterMove()
                if(map._zoom < 9){
                    dispatch(updateMapLayer(MAP_OUTDOOR))
                }else if(map._zoom >= 9) {
                    dispatch(updateMapLayer(MAP_LAYER_IGN))
                }
            });
        }
    }, [map])

    return <MapContainer
            whenReady={(e)=>{
                setMap(e.target)
            }}
            center={[46.671203, 3.3083]}
            zoom={6} scrollWheelZoom={true}
            className={"h-full w-full"}
            >

        <TileLayers />
        {(!theme && moseOverHike && (!hike || moseOverHike.id != hike.id) && !isEmpty(kmlData[moseOverHike.id])) &&
            <KmlLayer color={'#636d80'} zoomOn={false} key={'moseover'+moseOverHike.id} kmlData={kmlData[moseOverHike.id]} />}
        {hike && <>
            {!isEmpty(kmlData[hike.id]) && <KmlLayer key={hike.id} kmlData={kmlData[hike.id]} ><Popup>{hike.title}</Popup></KmlLayer>}
            {!isEmpty(hike.variants) && hike.variants.map(variant => !isEmpty(kmlData[variant.hikeId]) &&
                <KmlLayer key={`variant-${variant.hikeId}`} kmlData={kmlData[variant.hikeId]} color={'#636d80'} zoomOn={false}>
                    {!isEmpty(hikes[variant.hikeId]) && <Popup>{hikes[variant.hikeId].title}</Popup>}
                </KmlLayer>)}
        </>}

        <ThemeLayer />
        <HikeLayer />
        {showStops && <StopsLayer />}
        {showThemes && services && <ServicesLayer />}
    </MapContainer>
}


export default Map;